import { useState } from "react";
import Check from "@mui/icons-material/Check";
import Clear from "@mui/icons-material/Clear";
import Delete from "@mui/icons-material/Delete";
import { Box, Button, FormLabel, TextField, Tooltip } from "@mui/material";
import {
  useCreateContactMutation,
  useDeleteContactMutation,
  useUpdateContactMutation,
} from "app/api/companies";
import { Company } from "models/Company";
import { CompanyContact } from "models/CompanyContact";

type ContactFormProps = {
  contactToEdit?: CompanyContact;
  companyId: Company["id"];
  onClose: () => void;
};

const ContactForm: React.FC<ContactFormProps> = (props) => {
  const { contactToEdit, companyId, onClose } = props;

  const [name, setName] = useState(contactToEdit?.name || "");
  const [phone, setPhone] = useState(contactToEdit?.phone || "");
  const [email, setEmail] = useState(contactToEdit?.email || "");

  const [createContact, { isLoading: isCreatingContact }] = useCreateContactMutation();
  const [updateContact, { isLoading: isUpdatingContact }] = useUpdateContactMutation();
  const [deleteContact, { isLoading: isDeletingContact }] = useDeleteContactMutation();

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();

        (contactToEdit
          ? updateContact({ id: contactToEdit.id, companyId, name, phone, email })
          : createContact({ companyId, name, phone, email })
        )
          .unwrap()
          .then(() => onClose());
      }}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        mx: "auto",
        maxWidth: 400,
      }}
    >
      <FormLabel>{contactToEdit ? "Redigera kontakt" : "Skapa ny kontakt"}</FormLabel>

      <TextField
        name="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        label="Namn"
        variant="filled"
        fullWidth
        required
        autoComplete="new-password"
      />

      <TextField
        name="phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        label="Telefon"
        variant="filled"
        fullWidth
        required
        autoComplete="new-password"
      />

      <TextField
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        label="E-post"
        variant="filled"
        fullWidth
        required
        autoComplete="new-password"
      />

      <Tooltip title="Ta bort kontakt" arrow>
        <Button
          variant="outlined"
          color="error"
          startIcon={<Delete />}
          hidden={!contactToEdit}
          loading={isDeletingContact}
          sx={{ minWidth: 0, px: 1, ".MuiButton-startIcon": { mx: 0 } }}
          onClick={() => {
            if (!contactToEdit) return;

            deleteContact({ id: contactToEdit.id, companyId })
              .unwrap()
              .then(() => onClose());
          }}
        />
      </Tooltip>

      <Button variant="outlined" startIcon={<Clear />} sx={{ ml: "auto" }} onClick={onClose}>
        Avbryt
      </Button>

      <Button
        type="submit"
        variant="contained"
        startIcon={<Check />}
        disabled={!name || !phone || !email}
        loading={isCreatingContact || isUpdatingContact}
      >
        Spara
      </Button>
    </Box>
  );
};

export default ContactForm;
